import Vue from 'vue'
import './plugins/fontawesome'
import App from './App.vue'
import './main.css'
import VueRouter from 'vue-router'
//import VDragged from 'v-dragged'

import "./plugins/fontawesome";

import "./main.css";

import {consoleTecharge} from "@/plugins/consoleTecharge";

consoleTecharge.group(consoleTecharge.asInfo("Techarge: Felcana Symptom Checker App"));
consoleTecharge.log(`Version: ${process.env.FALCANA_VERSION}`);
consoleTecharge.log(`Api Version: ${process.env.API_VERSION}`);
consoleTecharge.log(`Git Branch/Tag: ${process.env.VUE_APP_GITHUB_REF}`);
consoleTecharge.log(`Git Commit: ${process.env.VUE_APP_GITHUB_SHA}`);
consoleTecharge.groupEnd();


import vueCustomElement from "vue-custom-element";
import VueTailwindModal from "vue-tailwind-modal";
import vClickOutside from "v-click-outside";
import VueGeolocation from 'vue-browser-geolocation';

Vue.use(vClickOutside);
Vue.use(VueGeolocation);

Vue.component("VueTailwindModal", VueTailwindModal);

Vue.use(vueCustomElement)
Vue.use(VueRouter)
//Vue.use(VDragged)

import {sync} from 'vuex-router-sync';
import router from "./router";
import store from "./store/index";

import Helpers from './mixins/helpers'

const unsync = sync(store, router);

Vue.config.productionTip = false;


/***
 * Before running npm run dev please comment the following vue Instance.!
 */

new Vue({
    router,
    store,
    beforeCreate() {
        this.$store.commit("initialiseStore")
    },
    render: (h) => h(App),
}).$mount("#app");


App.router = router;
Vue.customElement("symptom-felcon", App);